import CloseIcon from "@/common/images/icons/x.svg?react";
import "./SearchCard.scss";

interface ISearchCard {
  onClearHistoryItem?: () => void;
  children: React.ReactNode;
}

export const SearchCard = ({ onClearHistoryItem, children }: ISearchCard) => {
  if (!onClearHistoryItem) {
    return <div className="searchCard">{children}</div>;
  }

  return (
    <div className="searchCard">
      {children}
      {onClearHistoryItem && (
        <button className="clearBtn" onClick={onClearHistoryItem} aria-label="Clear">
          <CloseIcon />
        </button>
      )}
    </div>
  );
};
